/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Collapse, Descriptions, Empty, Row } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MapView from '../../../components/MapView';
import MonedaSelector from '../../../components/MonedaSelector';
import PlanSelector from '../../../forms/personal/PlanSelector';
import { getCoordenadasByDireccion } from '../../../utils';
import { formatoMonedaGenerico } from '../../../utils/converters';

const { Panel } = Collapse;
const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  text-align: left;
`;
const maxWidth = 1096;

const Cotizacion = ({ cotizaciones }) => {
  const [producto, setProducto] = useState();
  const [monedas, setMonedas] = useState();
  const [moneda, setMoneda] = useState();
  const [zoomMap, setZoomMap] = useState(15);
  const [marcadoMap, setMarcadorMap] = useState(true);

  function PanelHeader(props) {
    const { cotizacion } = props;

    return (
      <div style={{ display: 'grid' }}>
        <Row justify="start" align="middle" wrap={false}>
          <Col>
            <img
              src={`/images/aseguradoras/${cotizacion.aseguradoraEmpresa?.aseguradora?.codigo}.png`}
              alt="imagen aseguradora"
              width="100%"
              style={{
                verticalAlign: 'top',
                maxHeight: '68px',
                objectFit: 'contain'
              }}
            />
          </Col>
          <Col
            flex="auto"
            style={{
              textAlign: 'left',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              // textWrap: 'wrap',
              paddingLeft: 20,
              paddingRight: 20
            }}
          >
            <span>{cotizacion.aseguradoraEmpresa?.aseguradora?.nombre}</span>
          </Col>
        </Row>
      </div>
    );
  }

  const geocalizarMap = async (data) => {
    const { departamento, distrito, domicilio } = data;
    const direccionConcat = `${departamento}, ${distrito}, ${domicilio}`;

    const coordenadasEncontrada = await getCoordenadasByDireccion(
      direccionConcat
    );

    if (domicilio) {
      setZoomMap(17);
      setMarcadorMap(true);
    }

    if (coordenadasEncontrada) {
      return coordenadasEncontrada;
    }

    return undefined;
  };

  useEffect(() => {
    setProducto(cotizaciones[0].id_producto);
    const monedasConfiguradas = {};
    cotizaciones
      .flatMap((cotiz) => cotiz.planes)
      .forEach((item) => {
        monedasConfiguradas[item.moneda.codigo] = item.moneda;
      });

    const monedaGuaranies = Object.values(monedasConfiguradas).find(
      (item) => item.codigo === 'gs'
    );
    if (monedaGuaranies) {
      setMoneda(monedaGuaranies);
    } else {
      setMoneda(monedasConfiguradas[0]);
    }

    setMonedas(Object.values(monedasConfiguradas));
  }, []);

  return (
    <>
      <Header>
        Detalle de Cotización - {cotizaciones[0].producto.descripcion}
      </Header>
      {(producto === 2 || producto === 3) && (
        <>
          {cotizaciones[0].persona.distrito &&
            cotizaciones[0].persona.departamento &&
            cotizaciones[0].persona.domicilio && (
              <MapView
                coordenadas={geocalizarMap(cotizaciones[0].persona)}
                zoom={zoomMap}
                marker={false}
              />
            )}
          <Descriptions
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            column={{ md: 2, sm: 1, xs: 1 }}
            size="small"
            title=""
          >
            <Descriptions.Item label="Nombre y Apellido" span={2}>
              {cotizaciones[0]?.persona?.nombres || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Cédula de Identidad">
              {cotizaciones[0]?.persona?.cedula || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Domicilio">
              {cotizaciones[0]?.persona?.domicilio || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Contacto">
              {cotizaciones[0]?.persona?.celular || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Correo">
              {cotizaciones[0]?.persona?.correo || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {cotizaciones[0]?.persona?.departamento?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Ciudad">
              {cotizaciones[0]?.persona?.distrito?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Nacionalidad">
              {cotizaciones[0]?.persona?.nacionalidad || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Sexo">
              {cotizaciones[0]?.persona?.sexo || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Estado civil">
              {cotizaciones[0]?.persona?.estado_civil || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Lugar nacimiento">
              {cotizaciones[0]?.persona?.lugar_nacimiento || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Fecha nacimiento">
              {cotizaciones[0]?.persona?.fecha_nacimiento &&
                moment(
                  cotizaciones[0]?.persona?.fecha_nacimiento,
                  'YYYY-MM-DD'
                ).format('DD/MM/YYYY')}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
      {(producto === 4 || producto === 5 || producto === 6) && (
        <div>
          <br />
          {cotizaciones[0].inmueble?.latitud &&
            cotizaciones[0].inmueble?.longitud && (
              <MapView
                coordenadas={{
                  lat: cotizaciones[0].inmueble.latitud,
                  lng: cotizaciones[0].inmueble.longitud
                }}
                zoom={zoomMap}
                marker={marcadoMap}
              />
            )}

          <Descriptions
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            column={{ md: 2, sm: 1, xs: 1 }}
            size="small"
            title=""
          >
            <Descriptions.Item label="Asegurado" span={2}>
              {cotizaciones[0]?.persona?.nombres || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {cotizaciones[0].inmueble?.departamento?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Ciudad">
              {cotizaciones[0].inmueble?.distrito?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Dirección">
              {cotizaciones[0].inmueble?.domicilio || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Corriente Catastral Nro.">
              {cotizaciones[0].inmueble?.cuenta || 'N/A'}
            </Descriptions.Item>
          </Descriptions>
        </div>
      )}
      {producto === 1 && (
        <div>
          <Descriptions
            style={{ textAlign: 'left', paddingBottom: 40 }}
            bordered
            column={{ md: 2, sm: 1, xs: 1 }}
            size="small"
            title=""
          >
            <Descriptions.Item label="Asegurado" span={2}>
              {cotizaciones[0]?.persona?.nombres || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Marca">
              {cotizaciones[0].vehiculo?.marca?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Modelo">
              {cotizaciones[0].vehiculo?.modelo?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Submodelo">
              {cotizaciones[0].vehiculo?.submodelo?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Año">
              {cotizaciones[0].vehiculo?.aniosubmodelo?.descripcion || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Valor">
              {formatoMonedaGenerico(
                cotizaciones[0].vehiculo.moneda,
                cotizaciones[0].vehiculo.monto_asegurado,
                undefined
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Cant. ocupantes">
              {cotizaciones[0].vehiculo?.submodelo?.plazas || 'N/A'}
            </Descriptions.Item>
          </Descriptions>
        </div>
      )}
      <Header>Detalle de coberturas</Header>
      <Collapse
        style={{ marginTop: 20, marginBottom: 20 }}
        expandIconPosition="end"
      >
        {moneda &&
          cotizaciones.map((cotizacion, index) => {
            const planesEstandares = cotizacion.planes.filter(
              (item) => item.id_plan && moneda && item.id_moneda === moneda.id
            );
            const planesEspecificos = cotizacion.planes.filter(
              (item) => !item.id_plan && moneda && item.id_moneda === moneda.id
            );
            return (
              <Panel
                header={
                  <PanelHeader
                    cotizacion={cotizacion}
                    tipoProducto={producto}
                  />
                }
                key={index}
              >
                <div
                  style={{
                    textAlign: 'start',
                    maxWidth,
                    margin: 'auto',
                    overflowX: 'auto'
                  }}
                >
                  {(producto === 1 ||
                    producto === 2 ||
                    producto === 3 ||
                    producto === 4 ||
                    producto === 5 ||
                    producto === 6) && (
                    <>
                      {!(
                        cotizacion.planes.filter((item) => item.id_plan)
                          .length > 0
                      ) &&
                        !(
                          cotizacion.planes.filter((item) => !item.id_plan)
                            .length > 0
                        ) && <Empty description="No hay planes" />}
                      {planesEstandares.length > 0 && (
                        <>
                          <div
                            style={{
                              paddingBottom: 20,
                              display: 'inline-block',
                              textAlign: 'start'
                            }}
                          >
                            <PlanSelector
                              planes={planesEstandares}
                              hover={false}
                              disabled={false}
                              tituloAdicional="Detalle de Coberturas - Estándar"
                              vehiculo={cotizacion.vehiculo}
                              moneda={moneda}
                              opcionesDePago={{
                                numeroCuotas:
                                  cotizacion.vigencia?.cantidad_pagos
                              }}
                              infoMoneda
                              readonly
                            />
                            <br />
                            <br />
                          </div>
                        </>
                      )}
                      <br />
                      <br />
                      {planesEspecificos.length > 0 && (
                        <>
                          <div
                            style={{
                              paddingBottom: 20,
                              display: 'inline-block',
                              textAlign: 'start'
                            }}
                          >
                            <>
                              <PlanSelector
                                planes={planesEspecificos}
                                hover={false}
                                mostrarTipo
                                moneda={moneda}
                                opcionesDePago={{
                                  numeroCuotas:
                                    cotizacion.vigencia?.cantidad_pagos
                                }}
                                infoMoneda
                                readonly
                              />
                            </>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </Panel>
            );
          })}
      </Collapse>
      {monedas && monedas.length > 0 && (
        <MonedaSelector
          value={moneda.codigo}
          monedas={monedas}
          onChange={(e) => {
            const selected = monedas.filter(
              (mon) => mon.codigo === e.target.value
            )[0];
            setMoneda(selected);
          }}
        />
      )}
    </>
  );
};

export default Cotizacion;
